import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { useAddCampaignCodeMutation } from "@/redux/rtk/features/campaignCode/campaignCodeApi";
import { Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";

export default function AddCampaignCode({ onClose }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [addCampaignCode, { isLoading }] = useAddCampaignCodeMutation();

  const onFinish = async (values) => {
    const formData = {
      name: values.name,
    };

    const resp = await addCampaignCode(formData);
    if (resp.data) {
      form.resetFields();
      if (onClose) onClose();
    }
  };

  return (
    <div className="flex justify-center mt-5">
      <UserPrivateComponent permission="create-campaignCode">
        <Form
          className="w-full"
          onFinish={onFinish}
          colon={false}
          layout="vertical"
          form={form}>
          <div className="w-full px-10">
            <Form.Item
              label={t("campaignCode.name") || "Campaign Code Name"}
              name="name"
              rules={[
                { required: true, message: t("campaignCode.nameRequired") || "Please enter campaign code name" },
              ]}>
              <Input placeholder={t("campaignCode.name") || "Campaign Code Name"} />
            </Form.Item>
          </div>

          <Form.Item label="" className="px-10">
            <div className="flex items-center gap-2">
              <Button
                size={"large"}
                htmlType="submit"
                type="primary"
                loading={isLoading}>
                {t("common.create")}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </UserPrivateComponent>
    </div>
  );
}
